import React from 'react';
import Filterbar from 'components/molecule/Filterbar/Filterbar';
import { useFilterForm } from 'hooks/searchParams/useFilterForm/useFilterForm';
import { isFunction } from 'utils/helper/type';
import { FilterFormCtx } from '../filterFormCtx';

export function FilterInputsForm({ children, className, fields }) {
  const formProps = useFilterForm({ fields });
  const { onSubmit, onReset, hasFilter, formState } = formProps;
  const { isDirty } = formState;

  return (
    <FilterFormCtx.Provider value={formProps}>
      <Filterbar
        onSubmit={onSubmit}
        onCancel={onReset}
        classNames={className}
        applyDisabled={!isDirty}
        clearDisabled={!hasFilter && !isDirty}>
        {isFunction(children) ? children(formProps) : children}
      </Filterbar>
    </FilterFormCtx.Provider>
  );
}
